module.exports = __webpack_public_path__ + "img/sacred-harvest.cfd5b5d4.png";